import React from 'react';

import { Flex, HStack } from '@chakra-ui/react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { Input, Select } from 'components';
import { debouncePartner, debounceProject, debounceRegional } from 'utils/debounces';

export default function ClientData({ register, control }: UseFormReturn) {
  return (
    <Flex flexDir="column">
      <Input
        {...register('client.name')}
        label="Nome da Rota"
        placeholder="EX: Hospital Vaz Med LTDA"
      />
      <HStack
        mt={5}
        spacing={4}>
        <Controller
          control={control}
          name="client.costumer"
          render={({ field }) => (
            <Select
              label="Cliente"
              loadOptions={debouncePartner}
              {...field}
            />
          )}
        />
        <Input
          {...register('client.code')}
          label="Código da Rota"
          placeholder="FL013"
        />
      </HStack>

      <HStack
        mt={5}
        spacing={4}>
        <Controller
          control={control}
          name="client.regional"
          render={({ field }) => (
            <Select
              label="Regional"
              loadOptions={debounceRegional}
              {...field}
            />
          )}
        />
        <Controller
          control={control}
          name="client.project"
          render={({ field }) => (
            <Select
              label="Projeto"
              loadOptions={debounceProject}
              {...field}
            />
          )}
        />
      </HStack>
      <HStack
        mt={5}
        spacing={4}>
        <Controller
          control={control}
          name="client.contractCompany"
          render={({ field }) => (
            <Select
              label="Empresa Contratante"
              loadOptions={debouncePartner}
              viewProps={{ width: '49%' }}
              {...field}
            />
          )}
        />
      </HStack>
    </Flex>
  );
}
